// extracted by mini-css-extract-plugin
export default {"button":"button__ykjsS","active":"active__HrxhU","divider":"divider__fxVZq","tab_container":"tab_container__caaEO"};